import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  wrapper: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
  },
  content: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`,
  },
});

class AccessDenied extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.wrapper}>
        <h3 className={classes.content}>This site is reserved for trainers at The St. James.</h3>
      </div>
    );
  }
}

export default withStyles(styles)(AccessDenied);
